export enum Dataset {
  SOURCE = 'source',
  LANGUAGE = 'language',
  HIDE_PHONE = 'hidePhone',
}

export type TLanguageCode = 'EN' | 'ES';

export type THidePhone = string | boolean | undefined;

export type RootProps = {
  readonly source: string;
  readonly languageCode: TLanguageCode;
  readonly hidePhone: boolean;
};

export type RootState = {
  readonly isLoadedCountry: boolean;
  readonly findCountryCode: string;
  readonly isSubmitted: boolean;
  readonly isCaughtError: boolean;
};

export enum FormErrors {
  BUSINESS_EMAIL = 'Please enter a business email address.',
}
